import ProductRefillCard from '@/components/products/refill/ProductRefillCard';
import { Alert } from '@montugroup/design-system';
import {
  mapToProductRefillCardPrescription,
  mapToProductRefillCardProduct,
} from '../../../pages/escript/order-medication/util';
import type { AvailableProductsListProps } from './types';

export function AvailableProductsList({ products, hideEmptyAlert = false }: AvailableProductsListProps) {
  if (products.length === 0) {
    if (hideEmptyAlert) {
      return null;
    }

    return (
      <Alert variant="outlined" severity="info">
        You currently have no prescribed medication available
      </Alert>
    );
  }

  return (
    <>
      {products.map((product, index) => (
        <ProductRefillCard
          key={product.id + index}
          product={mapToProductRefillCardProduct(product)}
          prescription={mapToProductRefillCardPrescription(product)}
          cartEventInfo={{ name: product.name, price: product.price }}
          onlyMaxQuantity
          hideRepeats={true}
        />
      ))}
    </>
  );
}
